import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RoleBasedRouter = () => {
  const { currentUser, userRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/landing" replace />;
  }

  // Route users to their appropriate dashboard based on role
  switch (userRole) {
    case 'customer':
      return <Navigate to="/customer-dashboard" replace />;
    case 'creator':
      return <Navigate to="/seller-hub" replace />;
    case 'admin':
      return <Navigate to="/admin-dashboard" replace />;
    default:
      // Fallback to customer dashboard for unknown roles
      return <Navigate to="/customer-dashboard" replace />;
  }
};

export default RoleBasedRouter; 